<template>
    <section class="position-relative d-flex align-items-center py-5" id="numerology">
        <div class="container-xl">
            <transition name="component-fade" mode="out-in">
                <div v-if="message.success || message.error" class="alert h5 shadow"
                    :class="message.success ? 'alert-success' : 'alert-danger'"
                    role="alert"
                >
                    <span v-html="message.content"></span>
                    <button type="button" class="close ml-2"
                        @click="message.success = false; message.error = false"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </transition>
            <transition
            @before-enter="beforeEnter"
            @before-leave="beforeLeave"
            @enter="enter"
            @leave="leave"
            :css="false">

            <div class="row py-5 position-relative" v-if="show">
                <div class="col text-center text-white">
                    <h4>Rozwiń świadomość dzięki numerologii.</h4>
                    <h4 class="mb-5 pb-5">Wybierz datę urodzenia:</h4>
                    <form @submit.prevent="submitForm($event)">
                        <div class="form-row flex-sm-row flex-column pt-5">
                            <div class="form-group col-lg-2 col-md-3 col-sm-4 col-10 mr-lg-5 mr-sm-0 ml-auto mr-auto">
                                <select name="day" class="selectpicker form-control"
                                    @change="refresh($event)"
                                    data-title="Dzień">
                                    <option class="text-center" v-for="(item, key) in 31" :key="key"
                                        :value="key+1"
                                    >{{key+1}}</option>
                                </select>
                                <small class="invalid-feedback font-weight-bold" style="display: block" v-if="(validMessage && validMessage.day )">
                                    <span v-for="(el, key) in validMessage.day" :key="key">{{el}}</span>
                                </small>
                            </div>
                            <div class="form-group col-lg-2 col-md-3 col-sm-4 col-10 mx-md-5 mx-auto">
                                <select name="month" class="selectpicker form-control"
                                    @change="refresh($event)"
                                    data-title="Miesiąc">
                                    <option v-for="(item, key) in month" :key="key"
                                        :value="item.id"
                                    >{{item.name}}</option>
                                </select>
                                <small class="invalid-feedback font-weight-bold" style="display: block" v-if="(validMessage && validMessage.month )">
                                    <span v-for="(el, key) in validMessage.month" :key="key">{{el}}</span>
                                </small>
                            </div>
                            <div class="form-group col-lg-2 col-md-3 col-sm-4 col-10 ml-lg-5 ml-sm-0 mr-auto ml-auto">
                                <select name="year" class="selectpicker form-control"
                                    @change="refresh($event)"
                                    data-title="Rok">
                                    <option v-for="(item, key) in yearLength" :key="key" :value="getYear(key)">{{ getYear(key) }}</option>
                                </select>
                                <small class="invalid-feedback font-weight-bold" style="display: block" v-if="(validMessage && validMessage.year )">
                                    <span v-for="(el, key) in validMessage.year" :key="key">{{el}}</span>
                                </small>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-lg-2 col-md-3 col-sm-4 col-10 mx-auto mt-sm-5 mt-auto">
                                <button type="submit" class="btn btn-blue btn-lg w-100 rounded-0">OBLICZ</button>
                            </div>
                        </div>
                        <div v-if="data">
                            <ul>
                                <li v-for="(el, key) in data" :key="key">
                                    {{el}}
                                </li>
                            </ul>
                        </div>
                    </form>
                </div>
            </div>
            </transition>
        </div>
    </section>
</template>

<script>
    export default {
        data(){
            return {
                month: [
                    {id: 1, name: 'Styczeń'},
                    {id: 2, name: 'Luty'},
                    {id: 3, name: 'Marzec'},
                    {id: 4, name: 'Kwiecień'},
                    {id: 5, name: 'Maj'},
                    {id: 6, name: 'Czerwiec'},
                    {id: 7, name: 'Lipiec'},
                    {id: 8, name: 'Sierpień'},
                    {id: 9, name: 'Wrzesień'},
                    {id: 10, name: 'Październik'},
                    {id: 11, name: 'Listopad'},
                    {id: 12, name: 'Grudzień'}
                ],
                yearLength: 120,
                message:
                {
                    success: false,
                    error: false,
                    content: null,
                },
                show: false,
                data: null,
                validMessage: null,
            }
        },
        mounted(){
            this.show = true;
        },
        updated(){
            $('select').selectpicker({
                style: 'btn-secondary btn-lg rounded-0',
                size: 10,
            });

            if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
                $('.selectpicker').selectpicker('mobile');
            }
            $('.selectpicker').selectpicker('refresh');
        },
        methods: {
            getYear(key){
                return new Date().getFullYear() - key;
            },
            refresh(el){
                if(this.validMessage)
                {
                    let name = $(el.target).attr('name');
                    this.validMessage[name] = null;
                }
            },
            submitForm(ev){

                let _this = this;
                let form = new FormData();
                let _form = $(ev.target).serializeArray();

                $.each(_form, function () {
                    form.append(this.name, this.value);
                });

                axios
                .post('/get/numberology', form).then(response => {
                    this.data = response.data;

                    this.show = false;
                })
                .catch(error => {
                    if (error.response.status == 422){
                        this.validMessage = error.response.data.errors;
                        this.message.error = true;
                        this.message.content = 'Wybierz obowiązkowe pola!';
                    }
                })
            },
            beforeEnter: function (el) {
                el.style.opacity = 0,
                el.style.top = '-100px'
            },
            beforeLeave: function(el) {
                el.style.opacity = 1,
                el.style.top = 0
            },
            enter: function (el, done) {
                $(el).animate({
                    opacity: 1,
                    top: 0,
                },1000, function(){
                    done();
                })
            },
            leave: function (el, done) {
                let _this = this;

                $(el).animate({
                    opacity: 0,
                    top: '-100px',
                },1000, function(el){
                    _this.$router.push({ name: "details", params: {type: 'numerology', id: _this.data.id} })
                })
            },
        },
        watch:
        {
            'message.success'(el){
                let _this = this;
                if(el === true)
                {
                    setTimeout(function(){
                        _this.message.success = false;
                    }, 5000)
                }
            },
            'message.error'(el){
                let _this = this;
                if(el === true)
                {
                    setTimeout(function(){
                        _this.message.error = false;
                    }, 5000)
                }
            },
        }
    }
</script>
